<template>

    <div class="payment">
        <div v-if="!isLoading">
            <div class="mt-4 mb-4">
                <!--<booking-summary></booking-summary>-->
            </div>

            <div class="payment-wrapper ">


                <div v-if="false" class="mb-5">
                    <gift-vouchers-payment></gift-vouchers-payment>
                </div>

                <div class="has-shadow">
                    <!--<to-pay v-bind:isTodayPayment="true"></to-pay>
                    <to-pay v-bind:isTodayPayment="false"></to-pay>-->

                </div>

                <div class="p-3">
                    <payment-form v-if="paymentSession"
                                  v-bind:bookingType="'spa-day'"
                                  v-bind:paymentSession="paymentSession"
                                  v-bind:sessionId="session.Id"></payment-form>
                </div>



            </div>
        </div>

        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>



        <actions-bar>
            <template v-slot:actions>
                <div class="row">
                    <div class="col-12">
                     
                        <button v-on:click="onBack" class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>

                </div>
            </template>
        </actions-bar>

    </div>



</template>

<script>
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import Loader from '@/shared/components/Loader.vue';
    /*    import CurrentAction from '../components/CurrentAction.vue';*/
    import PaymentForm from '../components/PaymentForm.vue';
    /*    import GiftVouchersPayment from '../components/GiftVouchersPayment.vue';*/
    /*    import ToPay from '../components/ToPay.vue';*/

    import paymentapi from '@/shared/api/payment';

    import { store } from '../store/index';

    export default {
        name: 'SpaDayPayment',
        components: {
            ActionsBar,
            /*      CurrentAction,*/
            PaymentForm,
            //GiftVouchersPayment,
            Loader,

        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            total() {
                return store.getters.dayTotal;
            },
            search() {
                return store.getters.search;
            },
        },
        data() {
            return {
                paymentSession: null,
                isLoading: false,
                isSubmitting: false
            }
        },
        mounted() {
            var payload = {
                sessionId: this.session.Id,
                item: {
                    amount: this.total
                }
            };
            paymentapi.initSpaPayment(payload, t => {
                this.paymentSession = t
            });
            this.trackBeginPayment();
        },
        methods: {
            onContinue: function () {

                store.dispatch("confirmBooking", this.session.Id).then((t) => {
                    this.$router.push({ name: 'spa_day_confirmation', params: { id: this.session.Id } });
                });

            },
            onBack: function () {
                this.$router.push({ name: 'spa_day_summary', params: { id: this.session.Id } });

            },

            trackBeginPayment() {

                if (this.$gtm.enabled()) {

                    let items = [];
                    let total = 0;

                    if (this.search.spaDay != null) {
                        items.push({
                            "item_id": this.search.spaDay.PremierId,
                            "item_name": this.search.spaDay.DisplayName,
                            "quantity": +(this.search.guestCount),
                            "price": +(this.search.spaDay.bookingDetails.ActualPrice),
                            "item_category": "Spa Day"
                        })
                        total += +(this.search.spaDay.bookingDetails.ActualPrice) * +(this.search.guestCount);
                    }

                    if (this.search.selectedTreatmentExtras != null) {
                        for (var ei = 0; ei < this.search.selectedTreatmentExtras.length; ei++) {
                            let extraTreatment = this.search.selectedTreatmentExtras[ei];

                            items.push({
                                "item_id": extraTreatment.selection.duration.Code,
                                "item_name": extraTreatment.selection.treatment.DisplayName,
                                "quantity": 1,
                                "price": +(extraTreatment.selection.duration.Price),
                                "item_category": "Spa Day Add Ons"
                            })

                            total += +(extraTreatment.selection.duration.Price);
                        }
                    }

                    if (this.search.selectedMudExtras?.selection != null) {
                        items.push({
                            "item_id": this.search.selectedMudExtras?.code.Code,
                            "item_name": this.search.selectedMudExtras?.addOn.content.DisplayName,
                            "item_variant": this.search.selectedMudExtras?.code.Guests + " Guests",
                            "quantity": 1,
                            "price": +(this.search.selectedMudExtras.selection.ActualPrice),
                            "item_category": "Spa Day Add Ons"
                        })
                        console.log(this.search.selectedMudExtras);
                        total += +(this.search.selectedMudExtras.selection.ActualPrice);
                    }

                    //Only Upsells
                    for (var gi = 0; gi < this.search.guests.length; gi++) {
                        let guest = this.search.guests[gi];
                        let treatments = guest.treatments?.filter(item => !item.IsIncluded) ?? []
                        if (treatments.length) {
                            for (let ti = 0; ti < treatments.length; ti++) {
                                let treatment = treatments[ti];

                                items.push({
                                    "item_id": treatment.duration.Code,
                                    "item_name": treatment.duration.DisplayName,
                                    "quantity": 1,
                                    "price": +(treatment.duration?.PriceDifference),
                                    "item_category": "Upsells"
                                })

                                total += +(treatment.duration.PriceDifference);
                            }
                        }
                    }


                    window.dataLayer?.push({
                        'pageURL': '/spa/day/payment',
                        'event': 'add_payment_info',
                        'value': total,
                        'curency': 'GBP',
                        'ecommerce': {
                            'items': items
                        }
                    });
                }
            }


        }
    }
</script>


<style src="@/shared/css/payment.css"></style>

